import { postJSON } from 'common/services/api'
import { useMutation } from 'react-query'
import { CHECK_ADDRESS_QUERY_KEY, CHECK_ADDRESS_URL } from './queryConstants'

type AddressCheck = {
  addressId: string
  residentId: string
}

type UseCheckAddressReturn = {
  checkAddressUsedInRota: (values: AddressCheck) => Promise<any>
  isLoading: boolean
}

const useCheckAddress = (): UseCheckAddressReturn => {
  const createFunction = async (values: AddressCheck) => {
    return postJSON({
      url: CHECK_ADDRESS_URL,
      method: 'POST',
      json: values,
      isRota: true
    })
  }

  const { mutateAsync: createMutation, isLoading } = useMutation<
    any,
    unknown,
    any,
    unknown
  >([CHECK_ADDRESS_QUERY_KEY], createFunction)

  const checkAddressUsedInRota = async (values: any) => {
    try {
      const result = await createMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    checkAddressUsedInRota,
    isLoading
  }
}

export default useCheckAddress
